import { FC } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import { getSelectedBackground, setSelectedBackground } from "../state/layerMenu";

import LayerSubMenu from "./LayerSubMenu";

const LayerMenuBaseLayersSubmenu: FC = () => {
  const selectedBackground = useSelector(getSelectedBackground);
  const dispatch = useDispatch();

  return (
    <LayerSubMenu>
      <LayerSubMenu.Header>
        <FormattedMessage id="layerMenu.basemapsHeader" defaultMessage="Background" />
      </LayerSubMenu.Header>

      <LayerSubMenu.ItemList w="fit-content">
        <LayerSubMenu.Item
          active={selectedBackground === "topographic"}
          onClick={() => dispatch(setSelectedBackground("topographic"))}
        >
          <FormattedMessage id="layerMenuBaseMapSubmenu.topographic" defaultMessage="Topographic" />
        </LayerSubMenu.Item>

        <LayerSubMenu.Item
          active={selectedBackground === "satellite"}
          onClick={() => dispatch(setSelectedBackground("satellite"))}
        >
          <FormattedMessage id="layerMenuBaseMapSubmenu.satellite" defaultMessage="Satellite" />
        </LayerSubMenu.Item>

        <LayerSubMenu.Item
          active={selectedBackground === "dark"}
          onClick={() => dispatch(setSelectedBackground("dark"))}
        >
          <FormattedMessage id="layerMenuBaseMapSubmenu.dark" defaultMessage="Dark" />
        </LayerSubMenu.Item>
      </LayerSubMenu.ItemList>
    </LayerSubMenu>
  );
};

export default LayerMenuBaseLayersSubmenu;
